import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2>Hi dear!!! please wait</h2>
            <h5>Payment methods are coming soon don't worry</h5>
        </div>
    );
};

export default Payment;